import { ACTION_TYPE } from '../actions/actionTypes';

const { AUTH } = ACTION_TYPE;

const authReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH.UPDATE_PHONE_NUMBER:
      return { ...state, phoneNumber: action.payload.phoneNumber, error: null };
    case AUTH.UPDATE_EMAIL_ADDRESS:
      return { ...state, emailAddress: action.payload, error: null };
    case AUTH.UPDATE_IS_USER_EXISTING:
      return { ...state, isUserExisting: action.payload, error: null };
    case AUTH.REQUEST_OTP_SUCCESS:
      return { ...state, error: null };
    case AUTH.VERIFY_OTP_SUCCESS:
      return { ...state, token: action.payload.token, error: null };
    case AUTH.VALIDATE_TOKEN_SUCCESS:
      return {
        ...state, isAuthenticated: action.payload.isAuthenticated, otpTime: action.payload.otpTime, error: null,
      };
    case AUTH.AUTH_FAIL:
      return {
        ...state, token: null, isAuthenticated: false, error: action.payload.error, dsUserDetail: '',
      };
    case AUTH.LOGOUT:
      return {
        ...state, token: null, isAuthenticated: false, dsUserDetail: '',
      };
    case AUTH.SAVE_DS_USER_DETAIL:
      return {
        ...state, dsUserDetail: action.payload,
      };
    case AUTH.RESET_DS_USER_DETAIL:
      return {
        ...state, dsUserDetail: '',
      };
    default:
      return state;
  }
};

export default authReducer;
